import React, { FC, ReactNode, useContext } from 'react';
import { ThemeContext } from 'styled-components';

export interface DataFormatProps {
  children?: ReactNode;
}

const DataFormat: FC<DataFormatProps> = ({ children }) => {
  const theme = useContext(ThemeContext);

  return <>{(children || children === 0) ? children : theme?.formatters?.emptyData || ''}</>;
};

export default DataFormat;
